import {
  Component, Input, Output, EventEmitter,
} from '@angular/core';
import * as _ from 'lodash';

@Component({
  moduleId: module.id,
  selector: 'search-results-empty-state',
  templateUrl: 'search-results-empty-state.component.html',
  styleUrls: ['search-results-empty-state.component.scss']
})
export class SearchResultsEmptyStateComponent {
  @Input() isEmptyList: boolean = false;
  @Input() emptyListText: string = '';
  @Input() hasAdvancedSearch: boolean = true;

  @Output() adjustSearchClick = new EventEmitter();

  onAdjustSearchClick() {
    this.adjustSearchClick.emit();
  }
}
